import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const BranEIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M5.32208 17.2286H0.771429V9C0.771429 4.45549 4.45549 0.771429 9 0.771429C13.5445 0.771429 17.2286 4.45549 17.2286 9V17.2286H12.6779M5.32208 17.2286V11.3066H9M5.32208 17.2286H9M12.6779 17.2286V11.3066H9M12.6779 17.2286H9M9 11.3066V17.2286M10.3714 6.25733C10.3714 7.01474 9.75742 7.62874 9 7.62874C8.24258 7.62874 7.62857 7.01474 7.62857 6.25733C7.62857 5.49993 8.24258 4.88593 9 4.88593C9.75742 4.88593 10.3714 5.49993 10.3714 6.25733Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

BranEIcon.displayName = 'BranEIcon';
